import React from 'react';
import { Spinner as SP } from 'react-bootstrap';

const Spinner = () => (
  <SP animation="border" key={0} variant="info" className="m-3" />
);

export default Spinner;
